module.exports = __webpack_public_path__ + "img/framenew_box06.3e700cc9.jpg";